<div class="wrapper">
    <ion-spinner color="secondary"></ion-spinner>
    <p *ngIf="text">{{text}}</p>
</div>

